export const newEmployerCertificate = {
  // Page Title and Headers
  EMPLOYER_CERTIFICATE_PAGE_TITLE: "Employer Certificate",
  EMPLOYER_CERTIFICATE_HEADING: "Employer Certificate",
  EMPLOYER_CERTIFICATE_DESCRIPTION: "Generate and download your employer certificate",
  
  // Employer Certificate Header
  "Employer Certificate": "Employer Certificate",
  "employerCertificateTutorial":"See how can we order an employer certifcate",
  "employerCertificateWatch": "Watch",
  "employerCertificateDescription": "When you have received your first salary from us, you can request an employment certificate. An employment certificate may be required when applying for unemployment benefits.\n\nTo ensure that your certificate can be processed correctly, it is important to accurately fill in your working hours and the salary you have received from us. Please verify this information using your payslips before submitting your request.\n\nOnce you submit the employment certificate request, it will be processed and generated. After your certificate has been created, you will be able to download it directly from the portal at your convenience.",
  
  // Work Hours Required
  "Work Hours Required": "Work Hours Required",
  "workHoursRequiredDescription": "To generate an Employer Certificate, you need registered work hours in your Timesheet. If you haven't logged any hours yet, please add them first.",
  "Create Timesheet": "Create Timesheet",
  
  // Certificates Table
  "Your certificates": "Your certificates",
  "Search": "Search",
  "Date from": "Date from",
  "Date to": "Date to",
  "Order Certificate": "Order Certificate",
  "Duration": "Duration",
  "Issued Date": "Issued Date",
  "Action": "Action",
  "Certificate type": "Certificate type",
  "Edit": "Edit",
  "Edit certificate": "Edit certificate",
  "Download": "Download",
  "Delete": "Delete",
  "Delete certificate": "Delete certificate",
  "No data found": "No data found",

  // Stats cards (top of the Employer Certificate list page)
  "Total Certificates": "Total Certificates",
  "Hours Recorded": "Hours Recorded",
  "Active Contracts": "Active Contracts",

  // Delete Confirmation Modal
  "Delete Certificate": "Delete Certificate",
  "Are you sure you want to delete this certificate?": "Are you sure you want to delete this certificate?",
  "This action cannot be undone.": "This action cannot be undone.",
  "Yes, Delete": "Yes, Delete",
  "Cancel": "Cancel",
  
  // Certificate Information
  CERTIFICATE_INFO: "Certificate Information",
  EMPLOYMENT_PERIOD: "Employment Period",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  CERTIFICATE_TYPE: "Certificate Type",
  CERTIFICATE_DATE: "Certificate Date",
  
  // Actions
  GENERATE_CERTIFICATE: "Generate Certificate",
  DOWNLOAD_CERTIFICATE: "Download Certificate",
  PREVIEW_CERTIFICATE: "Preview Certificate",
  REQUEST_CERTIFICATE: "Request Certificate",
  
  // Certificate Details
  EMPLOYER_NAME: "Employer Name",
  EMPLOYEE_NAME: "Employee Name",
  POSITION: "Position",
  EMPLOYMENT_TYPE: "Employment Type",
  FULL_TIME: "Full Time",
  PART_TIME: "Part Time",
  
  // Status Messages
  CERTIFICATE_GENERATED_SUCCESS: "Certificate generated successfully",
  CERTIFICATE_DOWNLOAD_SUCCESS: "Certificate downloaded successfully",
  CERTIFICATE_REQUEST_SENT: "Certificate request sent successfully",
  NO_CERTIFICATES_FOUND: "No certificates found",
  LOADING_CERTIFICATES: "Loading certificates...",
  
  // Form Labels
  SELECT_PERIOD: "Select Period",
  CUSTOM_PERIOD: "Custom Period",
  CURRENT_YEAR: "Current Year",
  LAST_YEAR: "Last Year",
  ALL_TIME: "All Time",
  
  // Table Headers
  CERTIFICATE_LIST: "Certificate List",
  ISSUE_DATE: "Issue Date",
  PERIOD: "Period",
  STATUS: "Status",
  ACTIONS: "Actions",
  
  // Certificate Status
  PENDING: "Pending",
  APPROVED: "Approved",
  READY: "Ready",
  DOWNLOADED: "Downloaded",
  
  // Validation Messages
  PLEASE_SELECT_START_DATE: "Please select a start date",
  PLEASE_SELECT_END_DATE: "Please select an end date",
  END_DATE_MUST_BE_AFTER_START: "End date must be after start date",
  "Start date is required": "Start date is required",
  "End date is required": "End date is required",
  "Year is required": "Year is required",
  "Amount is required": "Amount is required",
  
  // Additional Info
  CERTIFICATE_PURPOSE: "Purpose of Certificate",
  ADDITIONAL_NOTES: "Additional Notes",
  OPTIONAL: "Optional",
  
  // New Order Form
  "Create New Order": "Create New Order",
  "Important": "Important",
  "All information you enter in the Employer Certificate will appear in Swedish in the final certificate.": "All information you enter in the Employer Certificate will appear in Swedish in the final certificate.",
  "Contract No.": "Contract No.",
  "Emp. name": "Emp. name",
  "Social Security Number": "Social Security Number",
  "12 digits": "12 digits",
  "Employment Details": "Employment Details",
  "Employment period": "Employment period",
  "Specify the employment period": "Specify the employment period",
  "Start date": "Start date",
  "The first day of the employment period": "The first day of the employment period",
  "End date": "End date",
  "The last day of employment (leave empty if currently working)": "The last day of employment (leave empty if currently working)",
  "Currently working": "Currently working",
  "Work Hours Recorded": "Work Hours Recorded",
  "All registered working hours entered in the Timesheet section and/or referenced in invoices are displayed here.": "All registered working hours entered in the Timesheet section and/or referenced in invoices are displayed here.",
  "Month/Year": "Month/Year",
  "Total Working Hours": "Total Working Hours",
  "The total number of working hours recorded for the complete month.": "The total number of working hours recorded for the complete month.",
  "Absence": "Absence",
  "The total number of absence hours recorded for the complete month.": "The total number of absence hours recorded for the complete month.",
  "Over Time": "Over Time",
  "The total number of overtime hours recorded for the complete month.": "The total number of overtime hours recorded for the complete month.",
  "Total Amount": "Total Amount",
  "Total Compensation SEK": "Total Compensation SEK",
  "In this column, enter the person’s total compensation for the month in SEK.": "In this column, enter the person’s total compensation for the month in SEK.",
  "Avg. Over Time": "Avg. Over Time",
  "Leave Days": "Leave Days",
  "Avg. Break Duration": "Avg. Break Duration",
  "Total Working Days": "Total Working Days",
  "The total number of working days recorded for the complete month.": "The total number of working days recorded for the complete month.",
  
  // Discontinuation Details
  "Discontinuation Details": "Discontinuation Details",
  "Reason why the employment has ended in whole or in part": "Reason why the employment has ended in whole or in part",
  "Reason type": "Reason type",
  "Describe reason": "Describe reason",
  "Type here...": "Type here...",
  "Select reason": "Select reason",
  "Other reason": "Other reason",
  "Contract ended": "Contract ended",
  "Resignation": "Resignation",
  "Termination": "Termination",
  "Resignation by employee": "Resignation by employee",
  "Termination by employer": "Termination by employer",
  "Mutual agreement": "Mutual agreement",
  "End of assignment": "End of assignment",
  "Retirement": "Retirement",
  "Redundancy / Laid off": "Redundancy / Laid off",
  "You are currently employed, so you cannot add a reason": "You are currently employed, so you cannot add a reason",
  
  // Salary Information
  "Information about the salary": "Information about the salary",
  "Year": "Year",
  "Select year": "Select year",
  "Hourly salary": "Hourly salary",
  "Salary type": "Salary type",
  "Hourly": "Hourly",
  "salaryTypeTooltip": "Employer certificates at Invozio are issued exclusively for hourly-wage employees. No other salary type can be selected.",
  "Amount": "Amount",
  "amountTooltip": "In this field, enter the person’s hourly wage in SEK for the selected year.",
  "Enter amount": "Enter amount",
  
  // Other Information
  "Other information": "Other information",
  "Add any additional notes for this certificate": "Add any additional notes for this certificate",
  "otherInfoDescription": "The individual has been employed by Invozio during the stated period and has not conducted business as a self-employed person within the scope of the assignment. All work has been performed as an employee of Invozio, which has acted as the formal employer and has been responsible for salary payments, tax deductions, employer contributions, and reporting to the Swedish Tax Agency. The individual is therefore to be regarded as an employee, not a self-employed contractor, in this context.",
  "seeAppendix": "See appendix 'Other information'.",
  "confirmAccurate": "I confirm that all information provided for the employment certificate is accurate and complete to the best of my knowledge. I understand that incorrect or incomplete information may affect my eligibility for unemployment benefits or other public compensation, and that I am personally responsible for the submitted information and any consequences arising from inaccuracies.",
  
  // Footer
  "Cancel": "Cancel",
  "Submitemployercertifcate": "Create",
  "Update": "Update",
  "Save Draft": "Save Draft",
  "Update Draft": "Update Draft",
  "Saving...": "Saving...",
  /* Create-confirmation dialog. The title states the outcome the user
     cares about (the certificate is DONE), the message says what they can
     do next, and the button labels drive the download CTA + dismiss pair
     on the alert.

     Prefixed rather than plain "Download certificate" / "Maybe later":
     this file is spread into sv-se.js / en-us.js BEFORE their inline
     entries, so a generic key (sv-se.js already maps `Done` to "OK")
     would be silently overridden further down the object. */
  "employerCertificateReadyTitle": "Your employer certificate is ready!",
  "employerCertificateReadyMessage": "We've generated your employer certificate. Download it now, or find it anytime under Your certificates.",
  "employerCertificateReadyDownload": "Download now",
  "employerCertificateReadyDownloading": "Preparing download...",
  "employerCertificateReadyLater": "Maybe later",
  "employerCertificateDownloadFailed": "We couldn't download the certificate just now. It's saved — try the download button in Your certificates list.",
  "employerCertificateUpdatedSuccessfully": "Employer certificate updated successfully",
  "employerCertificateDeletedSuccessfully": "Employer certificate deleted successfully",
  "somethingWentWrong": "Something went wrong",
  "Draft saved successfully": "Draft saved successfully",
  "Failed to save draft": "Failed to save draft",
  "Draft updated successfully": "Draft updated successfully",
  "Failed to update draft": "Failed to update draft",

  // Draft Certificate
  "Draft Employer Certificate": "Draft Employer Certificate",
  "Are you sure you want to delete this Draft Employer Certificate?": "Are you sure you want to delete this Draft Employer Certificate?",
  "Present": "Present",

  // Work Hours Empty State
  "No data found for selected period": "No data found for selected period",
  "You can still fill the fields manually if needed.": "You can still fill the fields manually if needed.",
  "No Data": "No Data",
  "No data": "No data",
};
